var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionClouds({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15a3.99 3.99 0 0 0 1.354 3H6v-.027a4.5 4.5 0 0 1 .797-8.963A5.998 5.998 0 0 1 12 6a5.998 5.998 0 0 1 5.23 3.059 5 5 0 0 0-3.308 2.048A4 4 0 0 0 9 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18a4 4 0 1 0-3.635-5.672A3 3 0 1 0 13 18h5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionClouds);
export default __webpack_public_path__ + "static/media/ic_action_clouds.a65537c050b8f5585867da22eba32d3d.svg";
export { ForwardRef as ReactComponent };